import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { TableTypes } from '@components/Table/constants';
import {
  getAIAssistants,
  getAIAssistantStatuses,
  getAIAssistantTypes,
} from '@services/requests/helpdeskAI';
import { DETAILS_CALL_HISTORY_AI } from '@constants/routes';
import { formatDuration } from '@ui/pages/AIVoiceAssist/helpers';
import GlobalExportType from '@constants/globalExportTypes';

import Table from '@components/Table';
import DateAccessor from '@common/MuiVirtualizedTable/components/accessors/DateAccessor';
import ActionButton from '@common/buttons/ActionButton/ActionButton';
import DetailsIcon from '@assets/icons/updated/details.svg';
import Actions from '@components/PsaContacts/components/actions/Actions';

import useStyles from './styles';

const AICallHistory = () => {
  const { push } = useHistory();

  const [assistants, setAssistants] = useState([]);
  const [types, setTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const classes = useStyles();

  const onMount = useCallback(() => {
    Promise.all([
      getAIAssistants(),
      getAIAssistantTypes(),
      getAIAssistantStatuses(),
    ]).then(res => {
      setAssistants(res[0]);
      setTypes(res[1]);
      setStatuses(res[2]);
    });
  }, []);

  useEffect(() => {
    onMount();
  }, [onMount]);

  const columns = [
    {
      name: 'Date',
      key: 'createdOn',
      filterName: 'createdOn',
      type: TableTypes.date,
      sortable: true,
      minWidth: 200,
      width: 200,
      isCustomAccessor: true,
      accessor: row => <DateAccessor value={row.createdOn} />,
    },
    {
      name: 'Caller Phone Number',
      key: 'callingNumber',
      sortable: true,
      searchable: true,
      minWidth: 225,
      type: TableTypes.phoneNumber,
    },
    {
      name: 'Agent Name',
      key: 'assistantName',
      searchable: true,
      sortable: true,
      type: TableTypes.dropdown,
      dropDownValues: assistants,
      filterByAutocomplete: 'assistantId',
      minWidth: 200,
    },
    {
      name: 'Phone Number',
      key: 'assistantPhoneNumber',
      minWidth: 180,
      type: TableTypes.phoneNumber,
    },
    {
      name: 'Evaluation Score',
      key: 'evaluationScore',
      minWidth: 180,
      sortable: true,
    },
    {
      name: 'Call Duration',
      key: 'callDuration',
      sortable: true,
      minWidth: 180,
      isCustomAccessor: true,
      accessor: row => <div>{formatDuration(row.callDuration)}</div>,
    },
    {
      name: 'Ticket ID',
      key: 'ticketId',
      searchable: true,
      isCustomAccessor: true,
      minWidth: 125,
      accessor: row => (
        <a href={row.ticketLink} target="_blank" rel="noreferrer">
          {row.ticketId}
        </a>
      ),
    },
    {
      name: 'Call ID',
      key: 'callId',
      minWidth: 300,
    },
    {
      name: 'Agent Level',
      key: 'assistantTypeName',
      searchable: true,
      sortable: true,
      type: TableTypes.dropdown,
      dropDownValues: types,
      filterByAutocomplete: 'assistantTypeId',
      minWidth: 200,
      width: 200,
    },
    {
      name: 'Call Status',
      key: 'callStatus',
      searchable: true,
      sortable: true,
      type: TableTypes.dropdown,
      dropDownValues: statuses,
      filterByAutocomplete: 'callStatus',
      minWidth: 200,
      width: 200,
    },
    {
      name: 'Actions',
      key: TableTypes.actions,
      type: TableTypes.actions,
      minWidth: 125,
      width: 125,
      accessor: row => (
        <ActionButton
          icon={<img src={DetailsIcon} alt="iconVisible" />}
          handler={() => {
            push(DETAILS_CALL_HISTORY_AI.replace(':id', row.id));
          }}
          toolTip="Details"
          classNameWrapper={classes.detailsButton}
        />
      ),
    },
  ];

  return (
    <div className={classes.container}>
      <Table
        resource="/HelpDeskCallLogs"
        columns={columns}
        defaultSort={{ fieldName: 'id', order: 'DESC' }}
        actionsComponent={
          <Actions syncDataIntoDatabase globalExportType={GlobalExportType.AiCallHistory} />
        }
      />
    </div>
  );
};

export default AICallHistory;
